import React from 'react';
import '../assets/styles/pages/portfolio.scss';

const Portfolio = () => {
  return (
    <div id="portfolio-content">
      <div id="portfolio-title">
        <h1>Portfólio</h1>
        <p>MEUS TRABALHOS</p>
      </div>
      <div className="separator"></div>
      <div className="text-title uppercase"><strong>Projetos</strong></div>
      <h1>EM BREVE</h1>
    </div>
  );
};

export default Portfolio;